import React, { useContext, useEffect } from "react";
import {
  initializeToken,
  initializeInspectionId,
  initializeretake,
  makeRequest,
  userLogs,
  patLogs,
  addUserAgentData,
  setLogging,
  startModel,
  startModelInt8,
  setInspectionID,
  setConditionResume,
  setMandatoryResume,
  setSubConditionResume,
  setSubMandatoryResume,
  setSubMandatorySubResume,
  setSubConditionSubResume,
  setResumeFlowAllow,
  setDamageCount,
  setWindShieldDamageCount,
  setRedisFlowSetFirstTime,
  initializeEmail,
  setResumeFlowCount,
  zizoApiCalling,
  getInspectionID,
  setPathData,
  setUserLogs,
  setTotalImageForAnalysisResume,
  setTotalImageFeedbackMssgResume,
  setImageFeedbackStatusNBtn,
  setImgFeedbackCount,
  setFeedbackCountResume,
  setFeedBackStatus,
  getTotalImageFeedbackMssgResume,
  setImageFeedbackResumeStatus,
  getImageFeedbackStatusNBtn,
  addImageToList,
  getTotalImageForAnalysisResume,
  setTotalImageFeedbackMssg,
  setTotalImageForAnalysisResumeByMe,
  resumeFlowFinalSubmitHandler,
  setKotakRecaptureCase,
  getKotakRecaptureCase,
  setKotakOldInsp,
  setClientIdUtils,
  setImgFeedbackFlag,
  setGuidance,
  setFeebackTimer,
  setCountDownTimer,
  remove360CompleteFlagFeedbackResume,
  setImageEnhancement,
  setWebpImageFormat,
  setIsIosDevice,
  setImgQualityFactor,
  setRedirectVideoToImgFlag,
  setKiwiValidationCheckData,
  setResumeTimeStamoSecondFlag,
  setResumeTimestampFlag,
  getResumeTimestampFlag,
  setportoModuleList,
  setKiwiValidationCustomerFlow
} from "../context/utils";
import { setBackendExternally } from "../partdetection_new/PartDetector";
import { AppContext } from "../context";
import loading from "../img/loading.gif";
import sampleBase64Img from "../img/sampleBase64Img";
import MobileDetect from "mobile-detect";
import { CUSTOM_DOCUMENT_UPLOAD } from "../utils_new/Constants";
import main from "progressbar.js";

let finalConditions = {};
let finalSubConditions = {};
let finalSubConditionsSub = {};
let mandatoryConditions = {};
let subMandatoryConditions = {};
let subMandatoryConditionsSub = {};
let startDateLog = new Date().getTime();
let endDateLog = 0;
let startdates = Date.now();
let userToken = undefined;
let userAgentData = "";
let windshiledModuleCount = false;
let damageModuleCount = false;
let fetchDataFromRedis = false;
let allowImageFeedbackResume = false;
let resumeFlowEmailAllow = true;
let logData = {};
let resumeInterval;
let complete360Flag = false;

const Loading = () => {
  const {
    setCondition,
    setPhone,
    setScreen,
    setClientId,
    setInspectionId,
    inspectionId,
    setConfig,
    setMandatory,
    setSubMandatory,
    setSubMandatorySub,
    setSubCondition,
    setSubConditionSub,
    setToken,
    setErrorMessage,
    setRetake,
    setCaseId,
    setCount,
    setRestrictUserIfallNotGreen,
    config,
    setUserEmail,
    setCurrentDamage,
    setTotalImageForAnalysis,
    setIsIOS,
    setCallOnceFeedBack,
    setFeedBackBtndisabled,
    setFeedbackReceived,
    setImageFeedbackPopupRef,
    setAutoRotate,
    setInputMetaData,
  } = useContext(AppContext);
  let hashData = window.location.hash.split("#");
  if (hashData.length > 1) {
    userToken = hashData[1];
  }
  if (hashData.length > 2) {
    userAgentData = hashData[2];
    addUserAgentData({ token: userToken, userAgentData: userAgentData });
  }

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  let isAndroid = /Android/.test(navigator.userAgent);
  let SetRetake_inspectionId;
  let reOpen;
  setIsIOS(isIOS);
  setIsIosDevice(isIOS);

  const loadCustomFont = (URL) => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @font-face {
        font-family: 'D-DIN';
        src: url('${URL}') format('truetype');
        
      }
      body {
        font-family: 'D-DIN', sans-serif;
      }
    `;
    document.head.appendChild(style);
  };

  const checkToken = async () => {
    if (userToken === undefined) {
      setErrorMessage("Unique token is missing. Please use a valid URL");
      setScreen("error");
    } else {
      const res = await makeRequest("/checkToken", { token: userToken });
      const data = await res.json();
      if (data.status === "error") {
        if (data.errorType === "missing") {
          setErrorMessage("Unique token is invalid. Please use a valid URL");
        } else if (data.errorType === "used") {
          setErrorMessage(data.configData["errors"]["used"]);
        } else if (data.errorType === "wrongpath") {
          setErrorMessage(
            Object.keys("errors").includes("invalid_personaId")
              ? data.configData["errors"]["invalid_personaId"]
              : "Invalid Persona Id",
          );
        } else {
          setErrorMessage(data.configData["errors"]["invalid"]);
        }
        setScreen("error");
      } else {
        if (data.errorType === "recapture") {
          setKotakRecaptureCase(true);
        }
        setLogging(data.setLogStatus);
        // console.log("token verification time", startdates - Date.now());
        startdates = Date.now();
        const userAgent = window.navigator.userAgent;
        let browserName;
        let browserVersion;
        setAutoRotate(true);
        if (isIOS && navigator.userAgent.includes("CriOS")) {
          browserName = "Google Chrome";
          browserVersion = userAgent.match(/CriOS\/(\S+)/)
            ? userAgent.match(/CriOS\/(\S+)/)[1]
            : null;
        } else if (
          userAgent.includes("Safari") &&
          !userAgent.includes("Chrome")
        ) {
          browserName = "Apple Safari";
          browserVersion = userAgent.match(/Version\/(\S+)/)[1] || null;
        } else if (isAndroid && navigator.userAgent.includes("Samsung")) {
          browserName = "Samsung Browser";
          browserVersion =
            userAgent.match(/SamsungBrowser\/(\d+\.\d+)/)[1] || null;
        } else if (isAndroid && navigator.userAgent.includes("Edg")) {
          browserName = "Edge Browser";
          var version =
            userAgent.match(/Edg\/(\d+\.\d+\.\d+\.\d+)/) ||
            userAgent.match(/Edge\/(\d+\.\d+\.\d+\.\d+)/) ||
            userAgent.match(/EdgA\/(\d+\.\d+\.\d+\.\d+)/);
          browserVersion = version ? version[1] : null;
        } else if (isAndroid && !navigator.userAgent.includes("Chrome")) {
          browserName = "other";
          browserVersion = "N/A";
        } else if (
          isAndroid &&
          !navigator.userAgent.split(")")[2].split("/").length !== 3
        ) {
          browserName = "Google Chrome";
          browserVersion = userAgent.match(/Chrome\/(\S+)/)[1] || null;
        } else {
          browserName = "other";
          browserVersion = "N/A";
        }

        let moduleSelect = false;
        let allModule = [];
        setInputMetaData(data?.inputMetaData);
        if (
          Object.keys(data.configData["intro-page"]).includes(
            "kiwi-validation-check",
          )
        ) {
          if (Object.keys(data.configData["intro-page"]).includes("kiwi-validation-check-customer-flow") && data.configData["intro-page"]["kiwi-validation-check-customer-flow"]) {
            if (data && Object.keys(data).includes("inputMetaData") && (data["inputMetaData"] && Object.keys(data["inputMetaData"]).includes("odometer"))) {
              if (data["inputMetaData"]["odometer"] !== null && data["inputMetaData"]["odometer"] !== "") {
                setKiwiValidationCustomerFlow(false);
              }
            }
          }
          setKiwiValidationCheckData(data?.inputMetaData);
          setKiwiValidationCheckData(data?.licensePlate);
        }
        if (
          Object.keys(data.configData).includes("allowImageEnhancement") &&
          data.configData["allowImageEnhancement"]
        ) {
          setImageEnhancement(true);
        }
        if (
          Object.keys(data.configData).includes("allowWebpFormat") &&
          data.configData["allowWebpFormat"]
        ) {
          setWebpImageFormat(true);
          if (Object.keys(data.configData).includes("webpImgQualityFactor"))
            setImgQualityFactor(data.configData["webpImgQualityFactor"]);
        }
        if (
          Object.keys(data.configData).includes("getRedirectImage") &&
          data.configData["getRedirectImage"]
        ) {
          setRedirectVideoToImgFlag(true);
        }
        if (
          Object.keys(data.configData).includes("storeResumeTimeStamp") &&
          data.configData["storeResumeTimeStamp"]
        ) {
          setResumeTimestampFlag(true);
        }
        if (
          Object.keys(data.configData["font"]).includes("url") &&
          data.configData["font"]["url"]
        ) {
          loadCustomFont(data.configData["font"]["url"]);
        } else {
          loadCustomFont(
            "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/Font_style/default/d-din.regular+(1).ttf",
          );
        }
        if (
          Object.keys(data.configData["video-page"]).includes(
            "restrictUserIfallNotGreen",
          )
        ) {
          setRestrictUserIfallNotGreen(
            data.configData["video-page"]["restrictUserIfallNotGreen"],
          );
        }
        data.configData["blocks"].map((e) => {
          allModule.push(e.tag);
          if (
            e["name"] === "Video Capture" ||
            e["name"] === "New Video Capture" ||
            e["name"] === "VinOdo Video Capture" ||
            e["name"] === "Stencil Video" ||
            e["name"] === "New Image App"
          ) {
            if (
              Object.keys(data.configData).includes("int8Model") &&
              data.configData["int8Model"]
            ) {
              startModelInt8();
            } else {
              setBackendExternally("webgl");
              startModel("car");
            }
            moduleSelect = true;
          }
          if (e["name"] === "New Image App") {
            setGuidance(data.configData, data.clientId);
          }
          if (e["name"] === "Bike Stencil") {
            if (
              Object.keys(data.configData).includes("int8Model") &&
              data.configData["int8Model"]
            ) {
              startModelInt8();
            } else {
              setBackendExternally("webgl");
              startModel("bike");
            }
            moduleSelect = true;
          }
          if (e["name"] === "Windshield Damage") {
            windshiledModuleCount = true;
          }
          if (e["name"] === "damage") {
            damageModuleCount = true;
          }
          if (e["name"] === "New ZIZO Capture") {
            if (
              Object.keys(data.configData).includes("int8Model") &&
              data.configData["int8Model"]
            ) {
              startModelInt8();
            } else {
              setBackendExternally("webgl");
              startModel("car");
            }
            zizoApiCalling(sampleBase64Img);
          }
        });
        try {
          const res = await makeRequest("/setRetake", {
            token: userToken,
            resumeFlow: data.configData["resumeFlow"],
            kotakRecaptureCase: getKotakRecaptureCase(),
          });
          if (res.ok) {
            // console.log("initialize inspection id", startdates - Date.now());
            startdates = Date.now();
            let retakeData = await res.json();
            SetRetake_inspectionId = retakeData.data;
            reOpen = retakeData.reOpen ? retakeData.reOpen : false;
            if (
              Object.keys(retakeData).includes("recaptureKotakCase") &&
              retakeData.recaptureKotakCase &&
              retakeData.oldInspectionId
            ) {
              setKotakOldInsp(retakeData.oldInspectionId);
            }
            setRetake(retakeData.retake);
            initializeretake(retakeData.retake);
            if (retakeData.status === "error") {
              setErrorMessage(config["errors"]["services"]);
              setScreen("error");
            } else {
              const userAgent = navigator.userAgent;
              const md = new MobileDetect(userAgent);

              const ratio = window.devicePixelRatio;

              logData = {
                position: 0,
                inspection_id: retakeData.data,
                client_id: data.clientId,
                token: userToken,
                browser_name: browserName,
                browser_version: browserVersion,
                os: isIOS ? "ios" : isAndroid && "android",
                app: moduleSelect ? "video" : "image",
                total_module: allModule.join(", "),
                user_agent: JSON.stringify({ device: ratio, userAgent: navigator.userAgent }),
                mobile_detect: JSON.stringify(md),
                module_count: allModule.length.toString(),
                case_id: data.caseId,
              };

              //setting resume flag in redis for m2
              if (
                Object.keys(data.configData).includes("resumeFlow") &&
                data.configData["resumeFlow"]
              ) {
                try {
                  makeRequest(`/resumeFlag/${SetRetake_inspectionId}`);
                } catch (err) {
                  console.log(
                    "error faces while setting resume flag in redis :: ",
                    err,
                  );
                }
              }

              //checking if email is saved or not
              if (
                Object.keys(data.configData).includes("resumeFlow") &&
                data.configData["resumeFlow"] &&
                reOpen
              ) {
                try {
                  if (
                    data.configData["email"] &&
                    data.configData["intro-page"]["show-email-option"]
                  ) {
                    let makereq = await makeRequest(
                      `/setResumeFlowEmail/${SetRetake_inspectionId}/GET`,
                    );
                    if (makereq.ok) {
                      const emailData = await makereq.json();
                      let fetchEmail = emailData.data ? emailData.data : "";
                      if (fetchEmail != "") {
                        resumeFlowEmailAllow = false;
                        initializeEmail(fetchEmail);
                        setUserEmail(fetchEmail);
                      }
                    }
                  }
                  let stepCountReq = await makeRequest(
                    `/setUserStepCount/${SetRetake_inspectionId}/GET`,
                  );
                  if (stepCountReq.ok) {
                    const stepCount = await stepCountReq.json();
                    if (stepCount) {
                      let finalresult = stepCount.path.split(", ");
                      setPathData(finalresult);
                    }
                  }
                } catch (err) {
                  console.log("fetch email redis error     ", err);
                }
              }

              //check if image feedback is available or not in resume flow
              if (
                Object.keys(data.configData).includes("resumeFlow") &&
                data.configData["resumeFlow"] &&
                reOpen &&
                Object.keys(data.configData).includes("imageFeedback")
              ) {
                try {
                  let feedbackImgByNiranjan, feedbackResult, feedbackImgByMe;
                  //fetching niranjan save images
                  let makeReqForAnalysis = await makeRequest(
                    `/fetchResumeTotImgAnalysis/${SetRetake_inspectionId}/GET`,
                  );
                  if (
                    makeReqForAnalysis.ok &&
                    makeReqForAnalysis.status === 200
                  ) {
                    const totImgAnalysis = await makeReqForAnalysis.json();
                    if (totImgAnalysis && totImgAnalysis.length !== 0) {
                      feedbackImgByNiranjan = totImgAnalysis;
                      allowImageFeedbackResume = true;
                      setTotalImageForAnalysisResume(totImgAnalysis);
                      setTotalImageForAnalysis(totImgAnalysis);
                      setImgFeedbackCount(totImgAnalysis.length);
                    }
                  }
                  //fetching images store by me
                  let makeReqForAnalysisByMe = await makeRequest(
                    `/fetchResumeTotImgAnalysisByMe/${SetRetake_inspectionId}/GET`,
                  );
                  if (
                    makeReqForAnalysisByMe.ok &&
                    makeReqForAnalysisByMe.status === 200
                  ) {
                    const totImgAnalysisByMe =
                      await makeReqForAnalysisByMe.json();
                    if (totImgAnalysisByMe && totImgAnalysisByMe.length !== 0) {
                      feedbackImgByMe = totImgAnalysisByMe;
                      allowImageFeedbackResume = true;
                      setTotalImageForAnalysisResumeByMe(totImgAnalysisByMe);
                    }
                  }
                  //fetching feedback
                  let makeReqForMsg = await makeRequest(
                    `/fetchResumeImageFeedbackMsg/${SetRetake_inspectionId}/GET`,
                  );
                  if (makeReqForMsg.ok && makeReqForMsg.status === 200) {
                    const totImgMsg = await makeReqForMsg.json();
                    if (totImgMsg && Object.keys(totImgMsg).length !== 0) {
                      allowImageFeedbackResume = true;
                      if (totImgMsg["testing"]) delete totImgMsg["testing"];
                      feedbackResult = totImgMsg;
                      setTotalImageFeedbackMssg(totImgMsg);
                      setTotalImageFeedbackMssgResume(totImgMsg);
                    }
                  }
                  //fetching feedback status
                  let makeReqForStatus = await makeRequest(
                    `/fetchResumeImagefeedbackStatus/${SetRetake_inspectionId}/GET`,
                  );
                  if (makeReqForStatus.ok && makeReqForStatus.status === 200) {
                    const feedbackStaus = await makeReqForStatus.json();
                    if (feedbackStaus && feedbackStaus["data"]) {
                      setImageFeedbackStatusNBtn(feedbackStaus["data"]);
                      if (feedbackStaus["data"][0] !== "") {
                        //Handling condition where feedback status is either [feedback, checking, no-feedback, feedback-resume]
                        setFeedBackStatus(feedbackStaus["data"][0]);
                        setFeedBackBtndisabled(feedbackStaus["data"][1]);
                        if (feedbackStaus["data"][0] === "Feedback") {
                          //running the same exact thing as it is in 15 sec timer
                          let tempmsgFeedback = {};
                          complete360Flag = true;
                          let totalMsg = getTotalImageFeedbackMssgResume();
                          for (let tag in totalMsg) {
                            if (totalMsg[tag].length > 0) {
                              tempmsgFeedback[tag] = totalMsg[tag];
                            } else if (totalMsg[tag].length === 0) {
                              getTotalImageForAnalysisResume().map((image) => {
                                if (image.currentTag === tag) {
                                  addImageToList(image);
                                } else if (
                                  !Object.keys(totalMsg).includes(
                                    image.currentTag,
                                  )
                                ) {
                                  addImageToList(image);
                                }
                              });
                            }
                          }
                          if (Object.keys(tempmsgFeedback).length > 0)
                            setFeedbackReceived(Object.keys(tempmsgFeedback));
                          if (Object.keys(tempmsgFeedback).length === 0) {
                            setFeedBackStatus("noFeedback");
                            setImageFeedbackResumeStatus(
                              "Feedback_Resume",
                              true,
                              insId,
                            );
                          }
                          setCallOnceFeedBack(false);
                        }
                        // if (feedbackStaus["data"][0] === "Feedback_Resume") {
                        //   setImgFeedbackFlag(true);
                        //   rersumeFeedbackCaller(retakeData.data);
                        //   complete360Flag = true;
                        //   resumeFlowFinalSubmitHandler(
                        //     data.configData["blocks"].filter(
                        //       (e) => e["tag"] === "360 Image"
                        //     )[0]["tag"]
                        //   );
                        // }
                        if (feedbackStaus["data"][0] === "noFeedback") {
                          //setImageFeedbackPopupRef(true);
                          //Not doing anything as since we are going to handle a case where if some 360 images left then it will be uploaded from backend at sucess page.
                          complete360Flag = true;
                        }
                        if (feedbackStaus["data"][0] === "checking") {
                          //setImgFeedbackFlag(true);   //used for adding extra layer of check if in some case timer run out but the status remain checing then this will run the timer again for 8 sec
                          //setFinalImgMsg(retakeData.data);
                          complete360Flag = -1;
                          //checking if all images been hit to niranjan or not or if whether images got hit but not been save to redis by niranjan (check by using feedback)
                          if (Object.keys(feedbackResult).length >= 8) {
                            setFeebackTimer(2000);
                            setCountDownTimer(2);
                          } else if (
                            feedbackImgByNiranjan.length < 8 &&
                            Object.keys(feedbackResult).length >= 8
                          ) {
                            if (
                              feedbackImgByNiranjan.length !==
                              feedbackImgByMe.length
                            ) {
                              feedbackImgByMe.map((e) => {
                                let filter = feedbackImgByNiranjan.filter(
                                  (image) =>
                                    image["currentTag"] === e["currentTag"],
                                );
                                if (filter.length === 0)
                                  feedbackImgByNiranjan.push(e);
                              });
                              setTotalImageForAnalysisResume(
                                feedbackImgByNiranjan,
                              );
                              setTotalImageForAnalysis(feedbackImgByNiranjan);
                            }
                            setFeebackTimer(2000);
                            setCountDownTimer(2);
                          } else if (feedbackImgByNiranjan.length >= 8) {
                            //in this case allow the user to submit the feedback again and update the timer from 15 seconds to 5 seconds
                            setFeebackTimer(5000);
                            setCountDownTimer(5);
                          }
                        }
                      } else {
                        //handling condition where feedback is empty string ""
                        complete360Flag = -1;
                        if (feedbackImgByNiranjan.length >= 8) {
                          //checking if all the feedback came or not if yes them simply decerease the timer
                          if (Object.keys(feedbackResult).length >= 8) {
                            setFeebackTimer(2000);
                            setCountDownTimer(2);
                          } else if (
                            Object.keys(feedbackResult).length >= 3 &&
                            Object.keys(feedbackResult).length < 8
                          ) {
                            setFeebackTimer(10000);
                            setCountDownTimer(10);
                          }
                          //insist of doing this i will simply allow the user to submit 360 again if all images got hit to niranjan
                          //complete360Flag = true;
                          //setImgFeedbackFlag(true);
                          //setFeedBackStatus("checking");
                          // setImageFeedbackResumeStatus(
                          //   "checking",
                          //   false,
                          //   retakeData.data
                          // );
                          //setFinalImgMsg(retakeData.data);
                        } else if (
                          feedbackImgByNiranjan.length < 8 &&
                          Object.keys(feedbackResult).length >= 8
                        ) {
                          if (
                            feedbackImgByNiranjan.length !==
                            feedbackImgByMe.length
                          ) {
                            feedbackImgByMe.map((e) => {
                              let filter = feedbackImgByNiranjan.filter(
                                (image) =>
                                  image["currentTag"] === e["currentTag"],
                              );
                              if (filter.length === 0)
                                feedbackImgByNiranjan.push(e);
                            });
                            setTotalImageForAnalysisResume(
                              feedbackImgByNiranjan,
                            );
                            setTotalImageForAnalysis(feedbackImgByNiranjan);
                          }

                          // complete360Flag = true;
                          // setImgFeedbackFlag(true);
                          // setFeedBackStatus("checking");
                          // setImageFeedbackResumeStatus(
                          //   "checking",
                          //   false,
                          //   retakeData.data
                          // );
                          // setFinalImgMsg(retakeData.data);

                          //Here again insist of doing this i will simply allow the user to submit 360 again if all feedback came but i will chnage the timer from 15 seconds to 5 seconds as all feedback already came.
                          setFeebackTimer(2000);
                          setCountDownTimer(2);
                        } else if (
                          feedbackImgByNiranjan.length < 8 &&
                          Object.keys(feedbackResult).length !==
                          feedbackImgByNiranjan.length &&
                          feedbackImgByNiranjan.length !==
                          feedbackImgByMe.length
                        ) {
                          // Handling the case where some images is not been reach to niranjan then in that case just allow the users to recapture the missing image again.
                          // feedbackImgByMe.map((e) => {
                          //   let filter = feedbackImgByNiranjan.filter(
                          //     (image) => image["currentTag"] === e["currentTag"]
                          //   );
                          //   if (filter.length === 0)
                          //     feedbackImgByNiranjan.push(filter[0]);
                          // });
                          // setTotalImageForAnalysisResume(feedbackImgByNiranjan);
                          // setTotalImageForAnalysis(feedbackImgByNiranjan);
                        }
                      }
                    }
                  }
                  //Now dont need to store the count to redis as since we are assuming niranjan store image.length is the count
                  // console.log("@3-1")
                  // let makeReqForCount = await makeRequest(
                  //   `/fetchResumeImgFeedbackCount/${SetRetake_inspectionId}/GET`
                  // );
                  // console.log("@3-2")
                  // if (makeReqForCount.ok && makeReqForCount.status === 200) {
                  //   console.log("@3-3")
                  //   const feedbackCount = await makeReqForCount.json();
                  //   console.log("@3-4  :::: ", feedbackCount)
                  //   if (feedbackCount && feedbackCount["data"]) {
                  //     console.log("@3-5 : ", feedbackCount["data"])
                  //     if (feedbackCount["data"] === 0) {
                  //       console.log("image feedback count is ::: ", feedbackCount["data"])
                  //       setImgFeedbackCount(feedbackCount["data"]);
                  //       setFeedbackCountResume(feedbackCount["data"]);
                  //     } else {
                  //       console.log("image feedback count is ::: ", feedbackImgByNiranjan.length)
                  //       setImgFeedbackCount(feedbackImgByNiranjan.length);
                  //       setFeedbackCountResume(feedbackImgByNiranjan.length);
                  //     }
                  //   }
                  // }
                } catch (err) {
                  allowImageFeedbackResume = false;
                  console.log("fetch image feedback redis error     ", err);
                }
              }

              //check if some photo is uploaded or not
              if (
                Object.keys(data.configData).includes("resumeFlow") &&
                data.configData["resumeFlow"] &&
                reOpen
              ) {
                try {
                  let makereq = await makeRequest(
                    `/fetchResumeFlow/${SetRetake_inspectionId}/GET`,
                  );
                  if (makereq.ok && makereq.status === 200) {
                    const allowFetchData = await makereq.json();
                    fetchDataFromRedis = allowFetchData.flag
                      ? allowFetchData.flag
                      : false;
                    setRedisFlowSetFirstTime(fetchDataFromRedis);
                  }
                } catch (err) {
                  console.log("fetch redis flow error");
                  fetchDataFromRedis = false;
                  setRedisFlowSetFirstTime(fetchDataFromRedis);
                }
              }

              if (Object.keys(data.configData).includes("kotak-vehicle-page")) {
                data.configData["blocks"].push(CUSTOM_DOCUMENT_UPLOAD);
              }
              setConfig(data.configData);
              data.configData["blocks"].map((e) => {
                if (e.name === "damage" && e.mandatory) {
                  setportoModuleList("Damage");
                } else if (e.name === "Windshield Damage" && e.mandatory) {
                  setportoModuleList("WindshieldDamage");
                } else {
                  if (e.values.length > 0 && e.mandatory) {
                    e.values.map((g) => {
                      setportoModuleList(`${e.tag}: ${g.tag}`);
                    });
                  } else if (e.mandatory) {
                    setportoModuleList(e.tag);
                  }
                }
              });
              setInspectionID(retakeData.data);
              initializeInspectionId(retakeData.data);
              setInspectionId(retakeData.data);
              setCaseId(data.caseId);
              // sendLogData(logData, logDataS3, data, retakeData.data);
              sendLogData(logData, {}, data, retakeData.data);
            }
          } else {
            setErrorMessage(config["errors"]["services"]);
            setScreen("error");
            return;
          }
        } catch (err) {
          setErrorMessage(config["errors"]["services"]);
          setScreen("error");
          console.log(err);
          return;
        }
        setClientIdUtils(data.clientId);
        setClientId(data.clientId);
        initializeToken(userToken);
        //In case of success
        setToken(userToken);
        setConfig(data.configData);
        data.configData["blocks"].map((e) => {
          if (e.name === "damage" && e.mandatory) {
            setportoModuleList("Damage");
          } else if (e.name === "Windshield Damage" && e.mandatory) {
            setportoModuleList("WindshieldDamage");
          } else {
            if (e.values.length > 0 && e.mandatory) {
              e.values.map((g) => {
                setportoModuleList(`${e.tag}: ${g.tag}`);
              });
            } else if (e.mandatory) {
              setportoModuleList(e.tag);
            }
          }
        });

        //setting resume flow
        if (
          Object.keys(data.configData).includes("resumeFlow") &&
          data.configData["resumeFlow"]
        ) {
          setResumeFlowAllow(data.configData["resumeFlow"]);
        }

        if (
          Object.keys(data.configData).includes("resumeFlow") &&
          data.configData["resumeFlow"] &&
          reOpen &&
          fetchDataFromRedis
        ) {
          const retakeRedis = await makeRequest(
            `/redisConfigValue/${SetRetake_inspectionId}/GET`,
          );
          const countRedis = await makeRequest(
            `/redisCountValue/${SetRetake_inspectionId}/GET`,
          );
          if (windshiledModuleCount) {
            const windshiledCount = await makeRequest(
              `/windshieldRedisCount/${SetRetake_inspectionId}/GET`,
            );
            if (windshiledCount.ok) {
              const countResult = await windshiledCount.json();
              setWindShieldDamageCount(countResult.count);
            }
          }
          if (damageModuleCount) {
            const damageCount = await makeRequest(
              `/damageRedisCount/${SetRetake_inspectionId}/GET`,
            );
            if (damageCount.ok) {
              const countResult = await damageCount.json();
              setCount(countResult.count);
              setDamageCount(countResult.count);
              setCurrentDamage(countResult.count);
            }
          }
          if (countRedis.ok) {
            const countResult = await countRedis.json();
            setResumeFlowCount(countResult.count);
          }
          if (retakeRedis.ok) {
            let res1 = await retakeRedis.json();

            // if (complete360Flag) {
            //   console.log(complete360Flag)
            //   const id360 = data.configData["blocks"].filter(e => e["tag"] === "360 Image")[0]["tag"];
            //   res1.conditions[id360] = "completed";
            //   res1.mandatoryConditions[id360] = "completed";
            // }

            if (
              ["client_hiib", "client_hiib_uat", ""].includes(data.clientId) &&
              Object.keys(data.configData).includes("imageFeedback")
            ) {
              let filterSingleImgData = data.configData["blocks"].filter(
                (e) => e["tag"] !== "360 Image",
              );
              const fetchSingleImgRedisResult = await makeRequest(
                `/fetchHiibSingleImgTag/${SetRetake_inspectionId}`,
              );
              if (fetchSingleImgRedisResult.ok) {
                let fetchSingleImgRedisTag =
                  await fetchSingleImgRedisResult.json();
                if (fetchSingleImgRedisTag.length > 0) {
                  //first handling multiple section
                  let multipleSertionUplodedTag = fetchSingleImgRedisTag.filter(
                    (tag) => tag.includes(":"),
                  );
                  filterSingleImgData.forEach((module) => {
                    if (module["subSections"]) {
                      //for multiple Image
                      let mainTagModule = module["tag"];
                      module["values"].forEach((value) => {
                        let subTagMainModule = value["tag"];
                        if (multipleSertionUplodedTag.length > 0) {
                          //handling the case where the some images uploaded on server
                          let flag = false;
                          multipleSertionUplodedTag.forEach((tag) => {
                            let mainTag = tag.split(":")[0].trim();
                            let subTag = tag.split(":")[1].trim();
                            if (
                              mainTag === mainTagModule &&
                              subTag === subTagMainModule
                            )
                              flag = true;
                          });
                          if (flag) {
                            res1.subConditions[module["id"]][value["name"]] =
                              "completed";
                            if (
                              Object.keys(res1.subMandatoryConditions).includes(
                                module["id"],
                              ) &&
                              Object.keys(
                                res1.subMandatoryConditions[module["id"]],
                              ).includes(value["name"])
                            ) {
                              res1.subMandatoryConditions[module["id"]][
                                value["name"]
                              ] = "completed";
                            }
                          } else {
                            res1.subConditions[module["id"]][value["name"]] =
                              "pending";
                            if (
                              Object.keys(res1.subMandatoryConditions).includes(
                                module["id"],
                              ) &&
                              Object.keys(
                                res1.subMandatoryConditions[module["id"]],
                              ).includes(value["name"])
                            ) {
                              res1.subMandatoryConditions[module["id"]][
                                value["name"]
                              ] = "pending";
                            }
                          }
                        } else {
                          //handling the case where no images got uplaoded but user had captured it
                          res1.subConditions[module["id"]][value["name"]] =
                            "pending";
                          if (
                            Object.keys(res1.subMandatoryConditions).includes(
                              module["id"],
                            ) &&
                            Object.keys(
                              res1.subMandatoryConditions[module["id"]],
                            ).includes(value["name"])
                          ) {
                            res1.subMandatoryConditions[module["id"]][
                              value["name"]
                            ] = "pending";
                          }
                        }
                      });
                      let outerFlag = false;
                      module["values"].map((e) => {
                        if (
                          res1.subConditions[module["id"]][e["name"]] !==
                          "completed"
                        ) {
                          outerFlag = true;
                        }
                      });
                      if (outerFlag) {
                        res1.conditions[module["id"]] = "pending";
                        if (module["mandatory"]) {
                          res1.mandatoryConditions[module["id"]] = "pending";
                        }
                      }
                      // if (multipleSertionUplodedTag.length > 0) {
                      //   multipleSertionUplodedTag.forEach(tag => {
                      //     let mainTag = tag.split(":")[0].trim();
                      //     let subTag = tag.split(":")[1].trim();
                      //     if (mainTag === mainTagModule) {
                      //       // console.log("present multiple");
                      //       let subtagModule = module["values"].filter(e => e.tag === subTag)[0];
                      //       //console.log("mainTag, subTag ::: ", mainTag, subTag, subtagModule)
                      //       res1.subConditions[module["id"]][subtagModule["name"]] = "completed";
                      //       if (Object.keys(res1.subMandatoryConditions).includes(module["id"]) && Object.keys(res1.subMandatoryConditions[module["id"]]).includes(subtagModule["name"])) {
                      //         res1.subMandatoryConditions[module["id"]][subtagModule["name"]] = "completed";
                      //       }
                      //     }
                      //     else {
                      //       //console.log("not present multiple")
                      //       let subtagModule = module["values"].filter(e => e["tag"] === subTag)[0];
                      //       res1.subConditions[module["id"]][subtagModule["name"]] = "pending";
                      //       if (Object.keys(res1.subMandatoryConditions).includes(module["id"]) && Object.keys(res1.subMandatoryConditions[module["id"]]).includes(subtagModule["name"])) {
                      //         res1.subMandatoryConditions[module["id"]][subtagModule["name"]] = "pending";
                      //       }
                      //     }
                      //   });
                      //   let flag = false;
                      //   console.log("subcondition value ::: ", res1.subConditions[module["id"]])
                      //   module["values"].map(e => {
                      //     //console.log("checking for pending ::: ", res1.subConditions[module["id"]][e["name"]])
                      //     if (res1.subConditions[module["id"]][e["name"]] !== "completed") {
                      //       flag = true;
                      //     }
                      //   })
                      //   // for (let subSec in module["values"]) {
                      //   //   if (res1.subConditions[module["id"]][subSec["name"]] !== "completed") {
                      //   //     flag = true;
                      //   //   }
                      //   // }
                      //   if (flag) {
                      //     res1.conditions[module["id"]] = "pending";
                      //     if (module["mandatory"]) {
                      //       res1.mandatoryConditions[module["id"]] = "pending";
                      //     }
                      //   }
                      // }
                      // else {
                      //   res1.conditions[module["id"]] = "pending";
                      //   if (module["mandatory"]) {
                      //     res1.mandatoryConditions[module["id"]] = "pending";
                      //   }
                      //   module["values"].forEach(subSec => {
                      //     res1.subConditions[module["id"]][subSec["name"]] = "pending";
                      //     if (Object.keys(res1.subMandatoryConditions).includes(module["id"]) && Object.keys(res1.subMandatoryConditions[module["id"]]).includes(subSec["name"])) {
                      //       res1.subMandatoryConditions[module["id"]][subSec["name"]] = "pending";
                      //     }
                      //   });
                      // }
                    } else {
                      //for single image
                      if (fetchSingleImgRedisTag.includes(module["id"])) {
                        res1.conditions[module["id"]] = "completed";
                        if (
                          Object.keys(res1.mandatoryConditions).includes(
                            module["id"],
                          )
                        ) {
                          res1.mandatoryConditions[module["id"]] = "completed";
                        }
                      } else {
                        res1.conditions[module["id"]] = "pending";
                        if (
                          Object.keys(res1.mandatoryConditions).includes(
                            module["id"],
                          )
                        ) {
                          res1.mandatoryConditions[module["id"]] = "pending";
                        }
                      }
                    }
                  });
                }
              }
            }

            if (getResumeTimestampFlag()) setResumeTimeStamoSecondFlag(true);
            setCondition(res1.conditions);
            setMandatory(res1.mandatoryConditions);
            setSubMandatory(res1.subMandatoryConditions);
            setSubMandatorySub(res1.subMandatorySub);
            setSubCondition(res1.subConditions);
            setSubConditionSub(res1.subConditionSub);

            //resumeFlow
            setConditionResume(res1.conditions);
            setMandatoryResume(res1.mandatoryConditions);
            setSubMandatoryResume(res1.subMandatoryConditions);
            setSubMandatorySubResume(res1.subMandatorySub);
            setSubConditionResume(res1.subConditions);
            setSubConditionSubResume(res1.subConditionSub);


            if (complete360Flag) {
              resumeFlowFinalSubmitHandler(
                data.configData["blocks"].filter(
                  (e) => e["tag"] === "360 Image",
                )[0]["tag"],
              );
            }
            if (complete360Flag === -1) {
              remove360CompleteFlagFeedbackResume(
                data.configData["blocks"].filter(
                  (e) => e["tag"] === "360 Image",
                )[0]["tag"],
              );
            }
          }
        } else {
          data.configData["blocks"].map((item) => {
            if (
              Object.keys(data.configData).includes("recaptureAfterSubmit") &&
              data.configData["recaptureAfterSubmit"] &&
              getKotakRecaptureCase()
            ) {
              finalConditions[item.id] = "completed";
            } else {
              finalConditions[item.id] = "pending";
            }
            if (item.mandatory) {
              if (
                Object.keys(data.configData).includes("recaptureAfterSubmit") &&
                data.configData["recaptureAfterSubmit"] &&
                getKotakRecaptureCase()
              ) {
                mandatoryConditions[item.id] = "completed";
              } else {
                mandatoryConditions[item.id] = "pending";
              }
            }
            if (item.subSections) {
              subMandatoryConditions[item.id] = {};
              finalSubConditions[item.id] = {};
              item.values.map((item2) => {
                if (item2.mandatory) {
                  if (
                    Object.keys(data.configData).includes(
                      "recaptureAfterSubmit",
                    ) &&
                    data.configData["recaptureAfterSubmit"] &&
                    getKotakRecaptureCase()
                  ) {
                    subMandatoryConditions[item.id][item2.name] = "completed";
                  } else {
                    subMandatoryConditions[item.id][item2.name] = "pending";
                  }
                }
                if (
                  Object.keys(data.configData).includes(
                    "recaptureAfterSubmit",
                  ) &&
                  data.configData["recaptureAfterSubmit"] &&
                  getKotakRecaptureCase()
                ) {
                  finalSubConditions[item.id][item2.name] = "completed";
                } else {
                  finalSubConditions[item.id][item2.name] = "pending";
                }
                if (item2.subSections) {
                  finalSubConditionsSub[item2.name] = {};
                  subMandatoryConditionsSub[item2.name] = {};
                  item2.values.map((item3) => {
                    finalSubConditionsSub[item2.name][item3.name] = "pending";
                    if (item3.mandatory) {
                      subMandatoryConditionsSub[item2.name][item3.name] =
                        "pending";
                    }
                  });
                }
              });
            }
          });

          setCondition(finalConditions);
          setMandatory(mandatoryConditions);
          setSubMandatory(subMandatoryConditions);
          setSubMandatorySub(subMandatoryConditionsSub);
          setSubCondition(finalSubConditions);
          setSubConditionSub(finalSubConditionsSub);

          //resumeFlow
          if (
            Object.keys(data.configData).includes("resumeFlow") &&
            data.configData["resumeFlow"]
          ) {
            setConditionResume(finalConditions);
            setMandatoryResume(mandatoryConditions);
            setSubMandatoryResume(subMandatoryConditions);
            setSubMandatorySubResume(subMandatoryConditionsSub);
            setSubConditionResume(finalSubConditions);
            setSubConditionSubResume(finalSubConditionsSub);

          }
        }
      }
    }
  };
  const sendLogData = async (value, value1, value2, insp) => {
    if (value2 !== null) {
      if (!reOpen) await userLogs(value, value1, true);
      else {
        await setUserLogs(value1);
      }
      patLogs("Entered to loading page", insp, "loading");
      userLogs({
        position: 8,
        last_page: "loading page",
        inspectionId: insp,
        pos: "loading",
      });
      endDateLog = new Date().getTime();
      userLogs({
        position: 12,
        loading_timer: `${endDateLog - startDateLog} ms`,
        inspectionId: insp,
        pos: "loading",
      });
      if (window.ReactNativeWebView || navigator.userAgent.indexOf("wv") > -1) {
        if (
          Object.keys(value2.configData).includes("rejectionOption") &&
          value2.configData["rejectionOption"]
        ) {
          setScreen("rejection");
        } else if (
          value2.configData["email"] &&
          value2.configData["intro-page"]["show-email-option"]
        ) {
          if (resumeFlowEmailAllow) {
            ["client_876"].includes(value.client_id)
              ? setScreen("email_holiday")
              : ["opes_prod", "opes_uat"].includes(value.client_id)
                ? setScreen("menuOpes")
                : ["liberty_dev"].includes(value.client_id)
                  ? setScreen("Liberty")
                  : setScreen("email");
          } else {
            if (fetchDataFromRedis || allowImageFeedbackResume) {
              if (
                ["client_1298", "client_1298_dev", "client_1298_prod"].includes(
                  value.client_id,
                )
              )
                if (["opes_prod", "opes_uat"].includes(value.client_id)) {
                  setScreen("menuOpes");
                } else {
                  ["liberty_dev"].includes(value.client_id)
                    ? setScreen("Liberty")
                    : setScreen("instructions");
                }
              else {
                if (["porto_seguros"].includes(value.client_id))
                  setScreen("instructions");
                else setScreen("restart");
              }
            } else {
              if (["opes_prod", "opes_uat"].includes(value.client_id)) {
                setScreen("menuOpes");
              } else {
                ["liberty_dev"].includes(value.client_id)
                  ? setScreen("Liberty")
                  : setScreen("instructions");
              }
            }
          }
        } else {
          if (fetchDataFromRedis || allowImageFeedbackResume) {
            if (
              ["client_1298", "client_1298_dev", "client_1298_prod"].includes(
                value.client_id,
              )
            )
              if (["opes_prod", "opes_uat"].includes(value.client_id)) {
                setScreen("menuOpes");
              } else {
                ["liberty_dev"].includes(value.client_id)
                  ? setScreen("Liberty")
                  : setScreen("instructions");
              }
            else {
              if (["porto_seguros"].includes(value.client_id))
                setScreen("instructions");
              else setScreen("restart");
            }
          } else {
            if (
              value2.configData["email"] &&
              !value2.configData["intro-page"]["show-email-option"]
            ) {
              ["client_876"].includes(value.client_id)
                ? setScreen("email_holiday")
                : ["opes_prod", "opes_uat"].includes(value.client_id)
                  ? setScreen("menuOpes")
                  : ["liberty_dev"].includes(value.client_id)
                    ? setScreen("Liberty")
                    : setScreen("email");
            } else {
              if (["opes_prod", "opes_uat"].includes(value.client_id)) {
                setScreen("menuOpes");
              } else {
                ["liberty_dev"].includes(value.client_id)
                  ? setScreen("Liberty")
                  : setScreen("instructions");
              }
            }
          }
        }
      } else if (
        isAndroid &&
        !navigator.userAgent.includes("Chrome") &&
        !navigator.userAgent.includes("Samsung") &&
        !navigator.userAgent.includes("Edg")
      ) {
        setPhone("android");
        setScreen("error");
      } else if (
        isAndroid &&
        navigator.userAgent.split(")")[2].split("/").length !== 3 &&
        !navigator.userAgent.includes("Samsung") &&
        !navigator.userAgent.includes("Edg")
      ) {
        setPhone("android");
        setScreen("error");
      } else if (
        Object.keys(value2.configData).includes("rejectionOption") &&
        value2.configData["rejectionOption"]
      ) {
        setScreen("rejection");
      } else if (
        value2.configData["email"] &&
        value2.configData["intro-page"]["show-email-option"]
      ) {
        if (resumeFlowEmailAllow) {
          ["client_876"].includes(value.client_id)
            ? setScreen("email_holiday")
            : ["opes_prod", "opes_uat"].includes(value.client_id)
              ? setScreen("menuOpes")
              : ["liberty_dev"].includes(value.client_id)
                ? setScreen("Liberty")
                : setScreen("email");
        } else {
          if (fetchDataFromRedis || allowImageFeedbackResume) {
            if (
              ["client_1298", "client_1298_dev", "client_1298_prod"].includes(
                value.client_id,
              )
            )
              if (["opes_prod", "opes_uat"].includes(value.client_id)) {
                setScreen("menuOpes");
              } else {
                ["liberty_dev"].includes(value.client_id)
                  ? setScreen("Liberty")
                  : setScreen("instructions");
              }
            else {
              if (["porto_seguros"].includes(value.client_id))
                setScreen("instructions");
              else setScreen("restart");
            }
          } else {
            if (["opes_prod", "opes_uat"].includes(value.client_id)) {
              setScreen("menuOpes");
            } else {
              ["liberty_dev"].includes(value.client_id)
                ? setScreen("Liberty")
                : setScreen("instructions");
            }
          }
        }
        sendCallback(value, value2.configData, insp);
      } else {
        if (fetchDataFromRedis || allowImageFeedbackResume) {
          if (
            ["client_1298", "client_1298_dev", "client_1298_prod"].includes(
              value.client_id,
            )
          )
            if (["opes_prod", "opes_uat"].includes(value.client_id)) {
              setScreen("menuOpes");
            } else {
              ["liberty_dev"].includes(value.client_id)
                ? setScreen("Liberty")
                : setScreen("instructions");
            }
          else {
            if (["porto_seguros"].includes(value.client_id))
              setScreen("instructions");
            else setScreen("restart");
          }
        } else {
          if (
            value2.configData["email"] &&
            !value2.configData["intro-page"]["show-email-option"]
          ) {
            ["client_876"].includes(value.client_id)
              ? setScreen("email_holiday")
              : ["opes_prod", "opes_uat"].includes(value.client_id)
                ? setScreen("menuOpes")
                : ["liberty_dev"].includes(value.client_id)
                  ? setScreen("Liberty")
                  : setScreen("email");
          } else {
            if (["opes_prod", "opes_uat"].includes(value.client_id)) {
              setScreen("menuOpes");
            } else {
              ["liberty_dev"].includes(value.client_id)
                ? setScreen("Liberty")
                : setScreen("instructions");
            }
          }
        }
        sendCallback(value, value2.configData, insp);
      }
    }
  };
  const sendCallback = (value, configData, insp) => {
    if (
      Object.keys(configData).includes("vmgFLowType") &&
      Object.keys(configData).includes("vmgUrl")
    ) {
      fetch(configData["vmgUrl"], {
        method: "POST",
        headers:
          configData["authorization"] === "" ||
            configData["authorization"] === null
            ? {
              "Content-Type": "application/json",
            }
            : {
              "Content-Type": "application/json",
              Authorization: configData["authorization"],
            },
        body: JSON.stringify({
          caseId: value.case_id,
          inspectionId: insp,
          webAppToken: value.token,
          status: "Url was opened",
          code: 1,
          // "imageUrl": urls
        }),
      })
        .then((response) => {
          // Handle response
          //console.log(response);
        })
        .catch((error) => {
          // Handle error
          console.error("Error:", error);
        });
    }
  };

  useEffect(() => {
    window.top.postMessage("appLoaded", "*");
    checkToken();
  }, []);

  return (
    <div className="result-wait">
      <img src={loading}></img>
      <h3>
        {document.referrer && document.referrer.includes("portoseguro.com")
          ? "Verificando o token ..."
          : "Verifying Token ..."}
      </h3>
    </div>
  );
};

export default Loading;

// let logDataS3 = {
//   date: Date.now(),
//   inspection_id: retakeData.data,
//   client_id: data.clientId,
//   token: userToken,
//   browser_name: browserName,
//   browser_version: browserVersion,
//   os: isIOS ? "ios" : isAndroid && "android",
//   app: moduleSelect ? "video" : "image",
//   total_module: allModule.join(", "),
//   camera_permission: "",
//   gyro_permission: "",
//   desktop_view: "",
//   model_initialized: "",
//   video_data: "",
//   user_step_covered: "",
//   image_upload_status: "",
//   final_image_Upload: "",
//   last_page: "",
//   mobile_detect: JSON.stringify(md),
//   module_count: allModule.length.toString(),
//   case_id: data.caseId,
//   loading_timer: "",
//   complete_module: "",
//   location_permission: ""
// };
